import { HomeScreen } from '@strata/react-page-templates';

import { AppRoutes } from 'services/routes';
import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const Home = () => {
    const { data: messages } = useGetHomeScreenMessagesQuery();

    return (
        <HomeScreen
            illustration={HomeScreen.Illustration.PHARMACIES}
            button={{ label: 'View Live Referrals', path: AppRoutes.liveReferrals }}
            welcomeMessagePartOne="Our care-driven marketplace platform provides fair access to payer-authorized specialty drug referrals. These live referrals identify specific patient care needs so you can easily access and compete for the referrals best suited to your care model."
            messages={messages}
            viewAllUpdatesUrl={AppRoutes.updatesHistory}
        />
    );
};
